var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.35166,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4979_48555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5746 6.85712H11.4318C9.87752 6.85712 8.68896 8.04568 8.68896 9.59995V15.0856H16.5517L14.4489 12.9828C14.0832 12.6171 14.0832 12.0685 14.4489 11.7028C14.8146 11.3371 15.3632 11.3371 15.7289 11.7028L19.386 15.3599C19.7517 15.7256 19.7517 16.2742 19.386 16.6399L15.7289 20.297C15.3632 20.6627 14.8146 20.6627 14.4489 20.297C14.0832 19.9313 14.0832 19.3827 14.4489 19.017L16.5517 16.9142H8.68896V22.3998C8.68896 23.9541 9.87752 25.1426 11.4318 25.1426H20.5746C22.1288 25.1426 23.3174 23.9541 23.3174 22.3998V9.59995C23.3174 8.04568 22.1288 6.85712 20.5746 6.85712Z",
    fill: "#9595B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4979_48555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2857,
    height: 18.2857,
    fill: "white",
    transform: "translate(6.85693 6.85715)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoutIcon.39dce0ab.svg";
export { ForwardRef as ReactComponent };